import Vue from 'vue'
// import Element from 'element-ui'
import {
    Button,
    Select,
    Option,
    ColorPicker,
    Input,
    Slider,
    InputNumber,
    Checkbox,
    Message
} from 'element-ui';
import locale from 'element-ui/lib/locale'
import lang from 'element-ui/lib/locale/lang/ja'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'

// Adsense
// import Adsense from 'vue-google-adsense/dist/Adsense.min.js'
// Vue.use(require('vue-script2'))
// Vue.use(Adsense)

// 公開時false
Vue.config.productionTip = false

locale.use(lang)

Vue.prototype.$message = Message;

Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(ColorPicker)
Vue.use(Input)
Vue.use(Slider)
Vue.use(InputNumber)
Vue.use(Checkbox)


new Vue({
    render: h => h(App),
}).$mount('#app')
